/* =========================================================
   Humans Against — Reviews Wall
   Sources: Reviews.io live API + Shopify metaobject UGC
            + Clipara videos + static fallback pool
   ========================================================= */
(function () {
  'use strict';

  /* ── Read Liquid-injected JSON islands ──────────────────── */
  function tryParse(id, fallback) {
    try { var el = document.getElementById(id); return el ? JSON.parse(el.textContent) : fallback; }
    catch (e) { return fallback; }
  }

  var ugcData   = tryParse('ha-ugc-data', []);
  var videoData = tryParse('ha-video-data', []);
  var pressData = tryParse('ha-press-data', []);

  /* ── Config from Liquid globals ─────────────────────────── */
  var STORE_ID        = window.HA_REVIEWS_IO_STORE  || '';
  var STAT_RATING     = window.HA_STAT_RATING       || '';
  var STAT_REVIEWS    = window.HA_STAT_REVIEWS      || '';
  var STAT_RECOMMEND  = window.HA_STAT_RECOMMEND    || '';
  var STAT_SACHETS    = window.HA_STAT_SACHETS      || '';
  var STAT_CUSTOMERS  = window.HA_STAT_CUSTOMERS    || '';
  var STAT_PHARMACIES = window.HA_STAT_PHARMACIES   || '';
  var STAT_CITIES     = window.HA_STAT_CITIES       || '';
  var SHOW_SAMPLE     = window.HA_SHOW_SAMPLE !== false;

  /* ── Video queue — cycle all before repeating ────────────── */
  var _vidQueue = [];
  var _vidIdx   = 0;

  function nextVideo() {
    var pool = getVideos();
    if (!pool.length) return null;
    if (_vidIdx >= _vidQueue.length) {
      /* Fisher-Yates shuffle into a fresh queue */
      _vidQueue = pool.slice();
      for (var i = _vidQueue.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = _vidQueue[i]; _vidQueue[i] = _vidQueue[j]; _vidQueue[j] = tmp;
      }
      _vidIdx = 0;
    }
    return _vidQueue[_vidIdx++];
  }

  /* ── Static fallback reviews pool ───────────────────────── */
  var staticReviews = [
    { name: 'Tanya',      text: 'Pleasantly surprised by the taste and how much it helped me feel more alive after a night out! Highly recommend, really well thought out product.', stars: 5, source: 'Reviews.io' },
    { name: 'Hannah',     text: "I was pleasantly surprised at the pick-up this gave me after several pints the night before! Gave me the energy I needed to spend the day with an excitable toddler.", stars: 5, source: 'Reviews.io' },
    { name: 'Somer',      text: "Easily soluble and not salty tasting like other food supplements — in fact it actually tastes delicious, like a juice. Perfect pick-me-up for any day you're feeling a little run down.", stars: 5, source: 'Reviews.io' },
    { name: 'Jeffrey',    text: 'Great product, really helped me function at work after a very heavy night. Came in a berry flavour, tasted amazing.', stars: 5, source: 'Reviews.io' },
    { name: 'Amy',        text: "Saved me! I'd drained myself on a trip down to London and desperately needed a boost before a client meeting. Honestly sorted me right out.", stars: 5, source: 'Reviews.io' },
    { name: 'Tiffany',    text: 'My energy levels have increased from 0–100 while I was working. I felt more sharp and focused. Super effective.', stars: 5, source: 'Reviews.io' },
    { name: 'Rachael L.', text: "Genuinely life saving! I've tried many supplements in the past but within about 30 mins of drinking my sachet, I felt full of life and raring to go. I'll never be without them again.", stars: 5, source: 'Trustpilot', pull: true },
    { name: 'Priya',      text: 'Was sceptical but the berry flavour is lovely and I felt totally functional the next morning. I took one before bed and another with breakfast.', stars: 5, source: 'Reviews.io' },
    { name: 'Marcus',     text: 'Wedding season saviour. Have now handed these out at four weddings to grateful friends.', stars: 5, source: 'Trustpilot' },
    { name: 'Olivia',     text: "I work shifts in A&E and use these on my turnaround days. It's the only thing that gets me functional without smashing caffeine.", stars: 5, source: 'Reviews.io' },
    { name: 'Dan',        text: 'Not a hangover cure — as advertised — but a proper pick-me-up. The ingredients list actually makes sense.', stars: 5, source: 'Reviews.io' },
    { name: 'Niamh',      text: "Took one after a 10K I wasn't trained for. Felt human again by lunchtime. Not just for hangovers!", stars: 5, source: 'Reviews.io' },
    { name: 'Kwame',      text: 'The packaging is gorgeous and the product does what it says on the tin. A rare combination for supplements.', stars: 5, source: 'Reviews.io' },
    { name: 'Sophie',     text: "Bought a box for my mum who was sceptical about the whole 'influencer supplement' thing. She's now a convert.", stars: 5, source: 'Reviews.io' },
    { name: 'Leo',        text: 'Honestly I was hungover anyway — but less so. And it tasted nice, which is more than I can say for the other stuff.', stars: 4, source: 'Trustpilot' },
    { name: 'Esther',     text: 'Subscribed after my second box. The 28-day guarantee sold me, but the fact it actually works kept me.', stars: 5, source: 'Reviews.io' },
    { name: 'Tom',        text: 'Picked one up in my local pharmacy on a whim before a stag do. Genuinely the best fiver I spent all weekend.', stars: 5, source: 'Reviews.io' },
    { name: 'Nadia',      text: "Love that it's vegan and no weird mystery blends. I can pronounce everything on the ingredients list.", stars: 5, source: 'Reviews.io' },
    { name: 'Charlie',    text: "Keep a couple in my handbag for emergency Sundays. They've yet to fail me.", stars: 5, source: 'Reviews.io' },
    { name: 'Bea',        text: "I run a café and start at 6am. One of these and a flat white, I'm unstoppable.", stars: 5, source: 'Reviews.io' },
    { name: 'Raj',        text: 'Was slightly gritty when I mixed it too quickly but tasted great once properly dissolved. Will buy again.', stars: 4, source: 'Reviews.io' },
    { name: 'Freya',      text: 'Did the school run without resenting my husband after only 4 hours sleep. Magic.', stars: 5, source: 'Trustpilot', pull: true },
    { name: 'Jordan',     text: "Tested it on a 'work trip' (read: boozy conference). Genuinely felt sharper in my 9am panel than I had any right to.", stars: 5, source: 'Reviews.io' },
    { name: 'Aisha',      text: 'I wish the sachets were slightly smaller for handbags but the product itself is 10/10.', stars: 4, source: 'Reviews.io' },
    { name: 'Nathan',     text: "I've tried Morning Recovery, Flyby, every electrolyte powder under the sun. This is the one I actually re-order.", stars: 5, source: 'Reviews.io' },
    { name: 'Zoe',        text: "The Sunday morning renaissance I didn't know I needed.", stars: 5, source: 'Reviews.io' },
    { name: 'Connor',     text: 'Works. Tastes fine. Brand is funny. Recommend.', stars: 5, source: 'Reviews.io' },
    { name: 'Maya',       text: "I'm pregnant so can't use it myself but gifted it to my partner. He thinks I'm a genius now.", stars: 5, source: 'Reviews.io' },
    { name: 'Tomás',      text: 'Pro cycling coach here — recommend it to my Cat 2 lot after long events. Proper rehydration support.', stars: 5, source: 'Reviews.io' },
    { name: 'Keira',      text: "Genuinely the best brand voice I've seen in the wellness space in years. And the product is good too.", stars: 5, source: 'Reviews.io' }
  ];

  /* ── Badge data — only include stats that are configured ────── */
  var badges = [
    { big: '24', small: 'active plant extracts & vitamins' },
    { big: '0',  small: 'mystery blends. Ever.' }
  ];
  if (STAT_RATING)     badges.unshift({ big: STAT_RATING + '/5',    small: 'average rating on Reviews.io' });
  if (STAT_REVIEWS)    badges.push(   { big: STAT_REVIEWS,           small: 'verified reviews' });
  if (STAT_RECOMMEND)  badges.push(   { big: STAT_RECOMMEND,         small: 'of humans would recommend' });
  if (STAT_SACHETS)    badges.push(   { big: STAT_SACHETS,           small: 'sachets shipped to date' });
  if (STAT_CUSTOMERS)  badges.push(   { big: STAT_CUSTOMERS + '+',   small: 'humans who\'ve tried it' });
  if (STAT_PHARMACIES) badges.push(   { big: STAT_PHARMACIES,        small: 'UK pharmacies stocking HA' });
  if (STAT_CITIES)     badges.push(   { big: STAT_CITIES,            small: 'cities consuming Humans Against' });

  /* ── Press pool — blocks first, sample fallback if enabled ── */
  var _samplePress = SHOW_SAMPLE ? [
    { masthead: 'Vogue',     quote: 'The supplement that finally looks the part on a bathroom shelf.',   cite: "Beauty Editor's Picks, 2026" },
    { masthead: 'The Times', quote: 'A pharmacist-backed formula with none of the usual wellness woo.', cite: 'Style, March 2026' },
    { masthead: 'GQ',        quote: "The closest we've seen to a functional morning-after ritual.",      cite: 'Grooming Awards, 2026' },
    { masthead: 'Grazia',    quote: 'Every hen-do host is buying these in bulk.',                        cite: 'The List, Feb 2026' }
  ] : [];
  var press = pressData.length ? pressData : _samplePress;

  /* ── Live Reviews.io data ───────────────────────────────── */
  /* Reviews.io API requires server-side auth — not callable from browser.
     Stats are set via the Shopify Customizer; reviews use the static pool
     plus any UGC metaobjects added in Shopify Admin. */

  /* ── Merged data getters ─────────────────────────────────── */
  function getReviews() {
    var ugcReviews = ugcData
      .filter(function (r) { return r.text; })
      .map(function (r) { return Object.assign({}, r, { source: r.source || 'Community' }); });
    return SHOW_SAMPLE ? ugcReviews.concat(staticReviews) : ugcReviews;
  }

  function getVideos() {
    return videoData.filter(function (v) { return v.video_url || v.poster; });
  }

  function getPhotos() {
    return ugcData
      .filter(function (r) { return r.photo; })
      .map(function (r) { return { src: r.photo, caption: r.source || 'Community', handle: r.handle || r.name }; });
  }

  /* ── Helpers ─────────────────────────────────────────────── */
  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  function stars(n) {
    var out = '<span class="rw-stars" aria-label="' + n + ' out of 5">';
    for (var i = 0; i < 5; i++) out += '<span class="rw-star">' + (i < n ? '★' : '☆') + '</span>';
    return out + '</span>';
  }

  /* ── Platform identity ───────────────────────────────────── */
  /* No SVG — innerHTML lowercases viewBox which breaks SVG parsing.
     Platform identity is conveyed by badge colour + label text alone. */

  /* Convert seconds integer to "M:SS" display string */
  function formatDuration(seconds) {
    if (!seconds) return '';
    var s = parseInt(seconds);
    if (isNaN(s) || s <= 0) return '';
    var m = Math.floor(s / 60);
    var sec = s % 60;
    return m + ':' + (sec < 10 ? '0' + sec : sec);
  }

  function platformKey(source) {
    if (!source) return '';
    var s = source.toLowerCase();
    if (s.indexOf('instagram') !== -1) return 'instagram';
    if (s.indexOf('tiktok') !== -1)    return 'tiktok';
    if (s.indexOf('whatsapp') !== -1)  return 'whatsapp';
    if (s.indexOf('facebook') !== -1)  return 'facebook';
    if (s.indexOf('snapchat') !== -1)  return 'snapchat';
    return '';
  }

  function platformBadge(source) {
    var key = platformKey(source);
    if (!key) return '';
    return '<div class="rw-platform-badge rw-platform-badge--' + key + '">' + esc(source) + '</div>';
  }

  /* ── Card builders ───────────────────────────────────────── */
  var tints = ['', 'rw-bg-cream', 'rw-bg-pink', 'rw-bg-pink2', 'rw-bg-dark'];

  function quoteCard(r) {
    var key = platformKey(r.source);
    /* Platform cards get their own class; generic ones get a random tint */
    var extra = key ? 'rw-platform--' + key : tints[Math.floor(Math.random() * tints.length)];
    return '<article class="wall-card wall-card--quote ' + extra + '">' +
      platformBadge(r.source) +
      stars(r.stars || 5) +
      '<p>' + esc(r.text) + '</p>' +
      '<div class="rw-meta"><cite>' + esc(r.name) + '</cite>' +
      (key ? '' : '<span class="rw-source">' + esc(r.source || 'Verified') + '</span>') +
      '</div></article>';
  }

  function pullCard(r) {
    return '<article class="wall-card wall-card--pull">' +
      '<span class="rw-mark" aria-hidden="true">"</span>' +
      '<p>' + esc(r.text) + '</p>' +
      '<cite>— ' + esc(r.name) + '</cite>' +
      '</article>';
  }

  function photoCard(p) {
    return '<article class="wall-card wall-card--photo">' +
      '<img src="' + esc(p.src) + '" alt="' + esc(p.caption) + '" loading="lazy">' +
      '<div class="rw-caption"><span>' + esc(p.caption) + '</span><strong>' + esc(p.handle) + '</strong></div>' +
      '</article>';
  }

  function videoCard(v) {
    var key        = platformKey(v.platform);
    var posterAttr = v.poster ? ' poster="' + esc(v.poster) + '"' : '';
    var bgStyle    = v.poster ? ' style="background-image:url(\'' + esc(v.poster) + '\')"' : '';

    if (v.video_url) {
      /* Inline social-style video — plays in the card */
      return '<article class="wall-card wall-card--video rw-video-inline"' + bgStyle + '>' +
        '<video class="rw-video-el" src="' + esc(v.video_url) + '"' + posterAttr +
          ' muted playsinline loop preload="metadata"></video>' +
        '<div class="rw-video-overlay" aria-hidden="true">' +
          '<span class="rw-play">&#9654;</span>' +
        '</div>' +
        (key ? '<div class="rw-video-platform rw-video-platform--' + key + '"></div>' : '') +
        '<div class="rw-video-meta">' +
          '<strong>' + esc(v.handle || '') + '</strong>' +
          (v.duration ? '<span>' + esc(formatDuration(v.duration)) + '</span>' : '') +
        '</div>' +
      '</article>';
    }

    /* No video URL yet — static poster card */
    return '<article class="wall-card wall-card--video"' + bgStyle +
      ' role="button" tabindex="0" aria-label="Video from ' + esc(v.handle || 'creator') + '">' +
      '<span class="rw-play" aria-hidden="true">&#9654;</span>' +
      (key ? '<div class="rw-video-platform rw-video-platform--' + key + '"></div>' : '') +
      '<div class="rw-video-meta">' +
        '<strong>' + esc(v.handle || '') + '</strong>' +
        (v.duration ? '<span>' + esc(formatDuration(v.duration)) + '</span>' : '') +
      '</div>' +
    '</article>';
  }

  function badgeCard(b) {
    return '<article class="wall-card wall-card--badge">' +
      '<strong>' + esc(b.big) + '</strong>' +
      '<span>' + esc(b.small) + '</span>' +
      '</article>';
  }

  function pressCard(p) {
    var masthead = p.logo
      ? '<img src="' + esc(p.logo) + '" alt="' + esc(p.masthead) + '" class="rw-masthead-logo" loading="lazy">'
      : '<div class="rw-masthead">' + esc(p.masthead) + '</div>';
    var inner =
      masthead +
      '<p>' + esc(p.quote) + '</p>' +
      '<cite>' + esc(p.cite) + '</cite>';
    return p.link
      ? '<a href="' + esc(p.link) + '" class="wall-card wall-card--press" target="_blank" rel="noopener">' + inner + '</a>'
      : '<article class="wall-card wall-card--press">' + inner + '</article>';
  }

  /* ── UK geographic social proof ─────────────────────────── */
  var geoMessages = [
    'From Shetland to Cornwall.',
    'Leeds-born, UK-wide.',
    'Ordered in every corner of the UK — England, Scotland, Wales and Northern Ireland.'
  ];
  if (STAT_CITIES) {
    geoMessages.push('Tried across ' + STAT_CITIES + ' towns and cities in the UK.');
  }

  function geoCard(text) {
    return '<article class="wall-card wall-card--geo">' +
      '<span class="rw-geo-tag">Humans Against UK</span>' +
      '<p>' + esc(text) + '</p>' +
      '</article>';
  }

  function shopCard() {
    var eyebrow = STAT_CUSTOMERS ? 'Join ' + esc(STAT_CUSTOMERS) + '+ humans' : 'Try Humans Against';
    return '<article class="wall-card wall-card--shop">' +
      '<p class="rw-shop-eyebrow">' + eyebrow + '</p>' +
      '<h3 class="rw-shop-title">You\'ve got sh*t to do tomorrow.</h3>' +
      '<p class="rw-shop-body">24 active ingredients. Pharmacist-formulated. No filler.</p>' +
      '<a href="/products/humans-against" class="rw-shop-btn">Shop now &#8594;</a>' +
      '</article>';
  }

  /* ── Batch builder ───────────────────────────────────────── */
  function buildBatch(size) {
    var allReviews = getReviews();
    var allPhotos  = getPhotos();
    var allVideos  = getVideos();

    var rq  = allReviews.slice().sort(function () { return Math.random() - .5; });
    var rp  = allPhotos.slice().sort(function ()  { return Math.random() - .5; });
    var rv  = allVideos.slice().sort(function ()  { return Math.random() - .5; });
    var rb  = badges.slice().sort(function ()     { return Math.random() - .5; });
    var rpr = press.slice().sort(function ()      { return Math.random() - .5; });

    var qi = 0, pi = 0, vi = 0, bi = 0, pri = 0;
    var pool = [];
    /* Video cadence: force a video every 3–5 cards */
    var nextVideoAt = 3 + Math.floor(Math.random() * 3);  /* 3, 4, or 5 */
    var cardsSinceVideo = 0;

    while (pool.length < size) {
      var forceVideo = allVideos.length > 0 && cardsSinceVideo >= nextVideoAt;
      var card = '';

      if (forceVideo) {
        var fv = nextVideo();
        card = fv ? videoCard(fv) : '';
        cardsSinceVideo = 0;
        nextVideoAt = 3 + Math.floor(Math.random() * 3);
      } else {
        var t = Math.random();
        if (t < 0.52) {
          if (!rq.length) { card = badgeCard(rb[bi++ % rb.length]); }
          else { var r = rq[qi++ % rq.length]; card = (r.pull === true || r.pull === 'true') ? pullCard(r) : quoteCard(r); }
        } else if (t < 0.70 && allPhotos.length > 0) {
          card = photoCard(rp[pi++ % rp.length]);
        } else if (t < 0.85) {
          card = badgeCard(rb[bi++ % rb.length]);
        } else if (t < 0.91) {
          card = press.length ? pressCard(rpr[pri++ % rpr.length]) : badgeCard(rb[bi++ % rb.length]);
        } else if (t < 0.97) {
          card = geoCard(geoMessages[Math.floor(Math.random() * geoMessages.length)]);
        } else {
          card = shopCard();
        }
        cardsSinceVideo++;
      }

      if (card) pool.push(card);
    }

    return pool.join('');
  }

  /* ── HTML5 video lightbox (Shopify CDN videos) ───────────── */
  function openVideoLightbox(videoUrl) {
    var existing = document.getElementById('rw-lightbox');
    if (existing) existing.remove();

    var lb = document.createElement('div');
    lb.id = 'rw-lightbox';
    lb.className = 'rw-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<div class="rw-lightbox__inner">' +
        '<button class="rw-lightbox__close" aria-label="Close video">' +
          '&#x2715;' +
        '</button>' +
        '<video src="' + esc(videoUrl) + '" autoplay playsinline controls ' +
          'style="width:100%;height:100%;object-fit:contain;display:block;background:#000;">' +
        '</video>' +
      '</div>';

    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('.rw-lightbox__close')) {
        lb.querySelector('video').pause();
        lb.remove();
      }
    });

    function onEsc(e) {
      if (e.key === 'Escape') {
        var vid = lb.querySelector('video');
        if (vid) vid.pause();
        lb.remove();
        document.removeEventListener('keydown', onEsc);
      }
    }
    document.addEventListener('keydown', onEsc);
    document.body.appendChild(lb);
  }

  /* ── Decorate + animate cards ────────────────────────────── */
  function decorate(container) {
    var cards = container.querySelectorAll('.wall-card:not(.is-decorated)');
    cards.forEach(function (card, i) {
      card.classList.add('is-decorated');

      var t = Math.random();
      if (t < 0.18)       card.classList.add('r-left');
      else if (t > 0.82)  card.classList.add('r-right');

      card.style.animationDelay = (Math.min(i, 12) * 40) + 'ms';

      if (card.classList.contains('rw-video-inline')) {
        /* ── Inline social-style video player ── */
        (function (c) {
          var vid     = c.querySelector('.rw-video-el');
          var overlay = c.querySelector('.rw-video-overlay');
          if (!vid) return;

          var isHovered    = false;
          var previewTimer = null;
          var isDesktop    = window.matchMedia('(hover: hover)').matches;

          function showOverlay(on) {
            if (overlay) overlay.style.opacity = on ? '1' : '0';
          }

          vid.addEventListener('play',  function () { showOverlay(false); });
          vid.addEventListener('pause', function () { showOverlay(true); });

          /* Click = toggle play/pause */
          c.addEventListener('click', function () {
            if (vid.paused) { vid.play(); } else { vid.pause(); }
          });

          if (isDesktop) {
            /* Desktop: hover plays fully; scroll-in gives a 3s silent preview */
            c.addEventListener('mouseenter', function () {
              isHovered = true;
              if (previewTimer) { clearTimeout(previewTimer); previewTimer = null; }
              vid.play();
            });
            c.addEventListener('mouseleave', function () {
              isHovered = false;
              vid.pause();
              if (previewTimer) { clearTimeout(previewTimer); previewTimer = null; }
            });

            if ('IntersectionObserver' in window) {
              new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                  if (e.isIntersecting) {
                    if (!isHovered) {
                      vid.play();
                      previewTimer = setTimeout(function () {
                        if (!isHovered) vid.pause();
                      }, 3000);
                    }
                  } else {
                    if (previewTimer) { clearTimeout(previewTimer); previewTimer = null; }
                    if (!isHovered) vid.pause();
                  }
                });
              }, { threshold: 0.5 }).observe(c);
            }

          } else {
            /* Mobile: autoplay muted when scrolled into view, pause when not */
            if ('IntersectionObserver' in window) {
              new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                  if (e.isIntersecting) { vid.play(); } else { vid.pause(); }
                });
              }, { threshold: 0.5 }).observe(c);
            }
          }
        })(card);

      } else if (card.classList.contains('wall-card--video')) {
        /* ── Static poster card (no video URL yet) → product page ── */
        (function (c) {
          var open = function () { window.location.href = '/products/humans-against'; };
          c.addEventListener('click', open);
          c.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
          });
        })(card);
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('is-in'); });
      }, { threshold: 0.1 });
      container.querySelectorAll('.wall-card:not(.is-in)').forEach(function (c) { io.observe(c); });
    }
  }

  /* ── Mount ───────────────────────────────────────────────── */
  var grids = document.querySelectorAll('[data-wall]');
  if (!grids.length) return;

  grids[0].innerHTML = buildBatch(18);
  if (grids[1]) grids[1].innerHTML = buildBatch(14);
  grids.forEach(decorate);

  /* ── Infinite scroll ─────────────────────────────────────── */
  var loader     = document.querySelector('[data-loader]');
  var loadBtn    = document.querySelector('[data-loadmore]');
  var scrollGrid = grids[1] || grids[0];
  var loadCount  = 0;
  var MAX_BATCHES = 8;

  function loadMore() {
    if (!loader || loadCount >= MAX_BATCHES) return;
    loader.classList.add('is-loading');
    loadCount++;
    setTimeout(function () {
      var tmp = document.createElement('div');
      tmp.innerHTML = buildBatch(14);
      var frag = document.createDocumentFragment();
      while (tmp.firstChild) frag.appendChild(tmp.firstChild);
      scrollGrid.appendChild(frag);
      decorate(scrollGrid);
      loader.classList.remove('is-loading');

      if (loadCount >= MAX_BATCHES && loadBtn) {
        loadBtn.textContent = 'See all ' + STAT_REVIEWS + ' reviews on Reviews.io →';
        loadBtn.onclick = function () {
          window.open('https://www.reviews.io/company-reviews/store/' + (STORE_ID || ''), '_blank', 'noopener');
        };
      }
    }, 420);
  }

  if (loadBtn) loadBtn.addEventListener('click', loadMore);

  if ('IntersectionObserver' in window && loader) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) loadMore(); });
    }, { rootMargin: '800px 0px' }).observe(loader);
  }
})();
